import RequestFactory from './RequestFactory'

const GMA_E2E_URL = process.env.REACT_APP_GMAE2E_URL

export const AzureADService = {
  searchUsers: (searchPhrase: string) =>
    RequestFactory.get(
      GMA_E2E_URL,
      '/api/azure-ad/search-users?searchPhrase=' + encodeURIComponent(searchPhrase)
    ),
}
